<template>
    <div class="container-fluid container-noticies-block container-blogs" v-if="all">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="container-title container-title--blue">
                        <p>Blogs</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12">
                    <div class="blogs-block">
                        <a class="blogs-block__item" :href="blog.latest.url" v-for="blog in all" :key="blog.id">
                            <img v-if="blog.image" :src="utils.image(blog.image, 200, 200)" alt="" />
                            <h1>{{ blog.title }}</h1>
                            <p>{{blog.latest.title}}</p>
                        </a>
                    </div>
                    <router-link to="/blogs" class="blogs-block__button">Todos os blogs</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import home from '@/store/home'
import utils from '@/utils'

export default {
    name: 'Blogs',
    data() {
        return {
            utils: utils,
        }
    },
    computed: {
        all: function() {
            return home.getters.blogs
        },
    },
    
}
</script>